import React, { useRef, useState } from "react";

import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import {
  Typography,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Link as MuiLink,
} from "@mui/material";

import { OnboardingInfoBox } from "components/onboarding/OnboardingInfoBox";
import { updateEstimatedEnergy } from "libLegacy/api/dashboard";
import { useToken } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
    gap: theme.spacing(3),
    backgroundColor: theme.palette.backgrounds.secondary,
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(1),
  },
  input: {
    marginBottom: theme.spacing(3),
  },
  errorText: {
    color: theme.palette.error.main,
  },
}));

const SCREEN_DATA = {
  title: "Entenda mais sobre a sua Geração estimada",
  body: [
    "Geração estimada em kWh é um dado que leva em consideração a capacidade do seu sistema e a incidência solar de sua região.",
  ],
  inputLabel: "Geração estimada mensal em kWh",
  btnSubmit: "Enviar dados",
  btnGoBack: "Voltar",
  goBack: "/admin/monitoring",
};

export const EstimatedGeneration = ({ history }) => {
  const { classes } = useStyles();
  const token = useToken();
  const estimatedEnergyRef = useRef<HTMLInputElement>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const prevMonthlyEstimatedEnergy =
    history.location.state?.monthlyEstimatedEnergyKwh;
  const setGlobalError = useSetError();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (estimatedEnergyRef.current) {
      const inputMinValue = 1;
      const estimatedEnergy = parseFloat(
        estimatedEnergyRef.current?.value || "0"
      );

      if (estimatedEnergy >= inputMinValue) {
        try {
          await updateEstimatedEnergy(token, estimatedEnergy);
          history.push(SCREEN_DATA.goBack);
        } catch (error) {
          // @ts-expect-error
          setGlobalError(error.response?.data?.error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setGlobalError(CustomCodes.INVALID_FORM);
        setIsLoading(false);
      }
    }
  };

  return (
    <Grid container className={classes.root} direction="column">
      <Typography variant="h1">Geração Estimada</Typography>
      <OnboardingInfoBox
        variant="success"
        title={SCREEN_DATA.title}
        body={SCREEN_DATA.body}
      />
      <form onSubmit={handleSubmit}>
        <NumericFormat
          customInput={TextField}
          allowNegative={false}
          className={classes.input}
          label={SCREEN_DATA.inputLabel}
          id="estimatedEnergy"
          required
          inputRef={estimatedEnergyRef}
          fullWidth
          variant="outlined"
          defaultValue={prevMonthlyEstimatedEnergy}
        />
        <Button fullWidth color="primary" variant="contained" type="submit">
          {isLoading ? (
            <CircularProgress size={30} color="inherit" />
          ) : (
            SCREEN_DATA.btnSubmit
          )}
        </Button>
        <Grid textAlign="center" paddingTop={2}>
          <MuiLink
            component={Link}
            to={SCREEN_DATA.goBack}
            variant="body1"
            underline="always"
          >
            {SCREEN_DATA.btnGoBack}
          </MuiLink>
        </Grid>
      </form>
    </Grid>
  );
};
